import * as Yup from 'yup'

export const channelsValidationRules = Yup.object().shape({
  name: Yup.string().required('name is required'),
});